<script lang="ts" setup>
import type { WpProject } from "@/stores/api";

defineProps<{ estate: WpProject }>();

const formatPrice = (value: number) => {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
</script>

<template>
    <div v-if="estate" class="bg-beige-300 pt-[40px] lg:pt-[51px] pb-[40px] lg:pb-0">
        <div class="container grid lg:grid-cols-3 gap-x-[32px]">
            <div class="relative w-full h-[177px] lg:h-[454px] col-span-2 mb-[24px] lg:mb-[-51px]">
                <img v-if="estate.acf && estate.acf.primary_image" :data-src="estate.acf.primary_image" class="lazyload w-full h-full object-cover" />
                <div v-if="estate.acf && estate.acf.label_text" class="sold-circle" v-html="estate.acf.label_text"></div>
                <div v-else-if="estate.acf && estate.acf.sold_percentage" class="sold-circle">
                    <span>reeds</span>
                    <span class="text-[130%] leading-[0.9]">{{ estate.acf.sold_percentage }}%</span>
                    <span class="leading-[1]">verkocht</span>
                </div>
            </div>

            <div class="lg:pl-[45px]">
                <div class="laud-underline mb-[24px] xs !hidden lg:!inline-grid" v-html="estate.acf.title"></div>
                <div class="lg:hidden text-24 font-medium mb-[2px]">{{ estate.post_title }}</div>
                <div class="grid grid-cols-1 md:gap-x-[40px] pt-[8px]">
                    <div v-if="estate.acf.items" class="flex flex-col gap-[8px] order-1">
                        <div v-for="item in estate.acf.items" class="flex flex-row gap-[8px] items-center">
                            <img :data-src="item.icon.url" alt="" class="h-[20px] lazyload" />
                            <div>{{ item.title }}</div>
                        </div>
                    </div>
                    <div v-if="estate.acf.description" class="order-2 text-14 lg:text-18 font-light leading-[28px] tracking-[0.11px] mt-[18px]" v-html="estate.acf.description"></div>
                </div>
                <div class="mb-[20px]"></div>
                <a
                    :href="estate.relative_link"
                    :data-project-readmore="estate.post_title"
                    class="cta-project-readmore inline-flex text-white font-bold bg-brown-100 items-center justify-center py-[12px] text-center hover:bg-beige-200 transition-colors hover:text-brown-200 px-[56px] mb-[32px] lg:mb-[51px]"
                >
                    Bekijk project
                </a>
            </div>
        </div>
    </div>
</template>
